module.exports = require("@seddi/three/addons/postprocessing/OutputPass.js");